import { App } from "../Enums/App";

export interface ICurrentHover {
    app: App;
    title: string;
    image: string;
    header: string;
    description: string;
}

export interface ILockedModal {
    visible: boolean;
    title: string;
    description: string;
    link: string;
    linkText: string;
}
